import { Directive, Inject, AfterViewInit, input } from "@angular/core";
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "jqxInput",
})
export class InputDisableDirective implements AfterViewInit {
  disabled = input(false, {
    transform: (value: boolean | string): boolean =>
      typeof value === 'string' ? ['1', 'true', ''].includes(value) : Boolean(value)
  });

  constructor(
    @Inject(jqxInputComponent)
    private __input: jqxInputComponent
  ) { }

  ngAfterViewInit() {
    this.__input.disabled(this.disabled());
  }
}
